/** Face artwork transcribed from the supplied GuPai deck photograph.
 * Coordinates describe the whole tile, not two generic dice squares.
 * Game identities, ranks and pip counts remain in the shared engine.
 */
type Point = readonly [number, number];
export interface DaaluuPip { x: number; y: number; red: boolean }
const oneTop: Point[] = [[20, 8]], oneBottom: Point[] = [[20, 78]];
const twoTop: Point[] = [[11, 8], [29, 8]], twoBottom: Point[] = [[11, 78], [29, 78]];
const threeTop: Point[] = [[8, 8], [20, 22], [32, 36]];
const threeBottom: Point[] = [[8, 50], [20, 64], [32, 78]];
const fourTop: Point[] = [[11, 8], [29, 8], [11, 22], [29, 22]];
const fourBottom: Point[] = [[11, 64], [29, 64], [11, 78], [29, 78]];
const fiveTop: Point[] = [...twoTop, [20, 22], [11, 36], [29, 36]];
const fiveBottom: Point[] = [[11, 50], [29, 50], [20, 64], ...twoBottom];
const sixBottom: Point[] = [[11, 50], [29, 50], [11, 64], [29, 64], ...twoBottom];
function face(plain: Point[], red: Point[] = []): DaaluuPip[] {
  return [...plain.map(([x, y]) => ({ x, y, red: false })), ...red.map(([x, y]) => ({ x, y, red: true }))];
}
export const DAALUU_FACE_DOTS: Readonly<Record<string, readonly DaaluuPip[]>> = {
  daaluu: face([[29, 8], [29, 22], [29, 36], [11, 50], [11, 64], [11, 78]],
    [[11, 8], [11, 22], [11, 36], [29, 50], [29, 64], [29, 78]]),
  uuluu: face([...fiveTop, ...sixBottom]),
  siiluu: face(sixBottom, fourTop),
  bajgar: face([...fiveTop, ...fiveBottom]),
  gaval: face(fiveBottom, fourTop),
  degee: face([...threeTop, ...sixBottom]),
  chavgants: face([], [...twoTop, [11, 30], [29, 30], [11, 56], [29, 56], ...twoBottom]),
  savar: face([...threeTop, ...fiveBottom]),
  dongo: face([...twoTop, ...sixBottom]),
  shor: face(sixBottom, oneTop),
  sarlag: face([...twoTop, ...fiveBottom]),
  shanaga: face(threeTop, fourBottom),
  nohoi: face(twoTop, fourBottom),
  buluu: face(fiveBottom, oneTop),
  // The double-three has the photograph's distinctive 1–1–2–1–1 arrangement.
  chans: face([[20, 8], [20, 24], [11, 43], [29, 43], [20, 62], [20, 78]]),
  chuu: face([...twoTop, ...threeBottom]),
  bohoon: face(threeBottom, oneTop),
  band: face([...twoTop, ...twoBottom]),
  yooz: face([], [...oneTop, ...oneBottom]),
};
